const apiBase =
  process.env.REACT_APP_API_URL?.replace(/\/$/, '') || 'https://server.mends.pro/api';

const apiV1 =
  process.env.REACT_APP_UNOFFICIAL_API_URL?.replace(/\/$/, '')
  || process.env.REACT_APP_CONTACTS_API_URL?.replace(/\/$/, '')
  || process.env.REACT_APP_WHATSAPP_API_URL?.replace(/\/$/, '')
  || `${apiBase.replace(/\/api$/, '')}/api/v1`;

const wsBase =
  process.env.REACT_APP_WEBSOCKET_URL?.replace(/\/$/, '')
  || (apiBase.includes('localhost') ? 'ws://localhost:5251' : 'wss://server.mends.pro');

export const config = {
  API_BASE_URL: apiBase,
  UNOFFICIAL_API_URL: apiV1,
  WHATSAPP_API_URL: process.env.REACT_APP_WHATSAPP_API_URL?.replace(/\/$/, '') || apiV1,
  WS_BASE_URL: wsBase,
};